module.exports = __webpack_public_path__ + "static/media/code.631927f8.png";